export default "__VITE_ASSET__CiB8Axe1__"